import { apiClient } from "./config";

/**
 * Get template presets
 * @param {title,types,page,per_page,} data
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const getTemplatePresets = async (
	data,
	successCallback = false,
	errorCallback = false,
	axiosConfig
) => {
	const { id, ...params } = data;

	try {
		const response = await apiClient.get(`/templates/plans/${id}/print-presets`, {
			params: params,
			...axiosConfig,
		});
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Get template preset detail
 * @param {id} data
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const getTemplatePresetDetail = async (
	{ params, config },
	successCallback = false,
	errorCallback = false
) => {
	const { id, ...othersParams } = params;

	try {
		const response = await apiClient.get(`/templates/print-presets/${id}`, {
			params: othersParams,
			...config,
		});
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Create new template plans
 * @param {name, description, year, active} params
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const createTemplatePreset = async (
	body,
	successCallback = false,
	errorCallback = false
) => {
	const { templateId } = body;

	try {
		const response = await apiClient.post(`/templates/plans/${templateId}/print-presets`, body);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Edit template preset
 * @param {} data
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const editTemplatePreset = async (data, successCallback = false, errorCallback = false) => {
	const { id, ...body } = data;
	try {
		const response = await apiClient.patch(`/templates/print-presets/${id}`, body);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Delete template plans
 * @param {id} params
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const deleteTemplatePreset = async (
	params,
	successCallback = false,
	errorCallback = false
) => {
	const { id } = params;
	try {
		const response = await apiClient.delete(`/templates/print-presets/${id}`);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Copy template plans
 * @param {id} params
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const copyTemplatePreset = async ({ params, config }) => {
	const { id } = params;
	const response = await apiClient({
		method: "COPY",
		url: `/templates/print-presets/${id}`,
		...config,
	});
	return response.data;
};
